<div id="wrapper" class="cm-overlay" [ngClass]="{'toggled': toggleFlag}" (click)="closePanels($event)">
    <app-left-navigation #leftNavigation></app-left-navigation>
    <main>
        <app-header></app-header>
        <router-outlet></router-outlet>
    </main>
</div>
<!-- <footer class="app-footer">
    <app-footer></app-footer>
</footer> -->